const calendarEventModalDimensions = {
  calendarEventModalWidth: 557,
  calendarEventModalHeight: 192,
}

export default calendarEventModalDimensions
